import automationsSagas from './automations.sagas';

export default automationsSagas;
